const TextTitle =({title, color,position})=>{
    return (
        <span style={{ fontFamily: "MSPAINT" }}  className={`text-center lg:text-${position} text-[46px] leading-[64px] text-${color} font-ComicSansMS`}>
            {title}
        </span>
    )
}

export default TextTitle;